import React from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridDetalle } from "../../../Componentes/Basicos/LVGridDetalle";
import LVButtonAccion from "../../../Componentes/Basicos/LVButtonAccion";

class ABM_EEX_Clientes_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true
    };
  }

  getData = async (IdClave) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const { ABM_EEX_Clientes: { function_ABM_EEX_Clientes_Leer } } = require('neftis7_apicaller');
      const resultData = await function_ABM_EEX_Clientes_Leer(IdClave);
      this.setState({ data: resultData.data, loading: false });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  componentDidMount = async () => {
    this.getData(this.props.data.data.IdCliente)
  };

  render() {
    return (
      <React.Fragment>

        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", alignItems: "flex-start" }}>
          {this.state.loadingPersonasRelevantes ? null : (
            <>
              {this.state.data && this.state.data.PersonasRelevantes && this.state.data.PersonasRelevantes.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data.PersonasRelevantes}
                    Titulo="Personas Relevantes"
                  >
                    <Column caption="Nombre" dataField="Nombre" width="70" alignment="Left" dataType="string" />
                    <Column caption="Apellido" dataField="Apellido" width="100" alignment="Left" dataType="string" />
                    <Column caption="Cargo" dataField="Cargo" width="200" alignment="Left" dataType="string" />
                    <Column caption="Telefono" dataField="Telefono" width="150" alignment="Left" dataType="string" />
                    <Column caption="E-Mail" dataField="Email" width="200" alignment="Left" dataType="string" />
                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingLocaciones ? null : (
            <>
              {this.state.data && this.state.data.Locaciones && this.state.data.Locaciones.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data.Locaciones}
                    Titulo="Locaciones"
                  >
                    <Column caption="Código" dataField="CodigoLocacionCliente" width="70" alignment="Left" dataType="string" />
                    <Column caption="Calle" dataField="Calle" width="150" alignment="Left" dataType="string" />
                    <Column caption="Numero" dataField="Numero" width="100" alignment="Left" dataType="string" />
                    <Column caption="Piso" dataField="Piso" width="100" alignment="Left" dataType="string" />
                    <Column caption="Dpto." dataField="Dpto" width="100" alignment="Left" dataType="string" />
                    <Column caption="Teléfono" dataField="TelefonoCelular" width="200" alignment="Left" dataType="string" />
                    <Column caption="E-Mail" dataField="Email" width="200" alignment="Left" dataType="string" />

                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingPlantas ? null : (
            <>
              {this.state.data && this.state.data.ListPlantas && this.state.data.ListPlantas.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data.ListPlantas}
                    Titulo="Plantas"
                  >
                    <Column caption="Código" dataField="CodigoPlanta" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Descripcion" width="200" alignment="Left" dataType="string" />

                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}

          <br />

          {this.state.loadingEmpresas ? null : (
            <>
              {this.state.data && this.state.data.ListEmpresas && this.state.data.ListEmpresas.length > 0 ? (
                <>
                  <LVGridDetalle
                    dataSource={this.state.data.ListEmpresas}
                    Titulo="Empresas"
                  >
                    <Column caption="Código" dataField="CodigoEmpresa" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Descripcion" width="200" alignment="Left" dataType="string" />

                  </LVGridDetalle>
                </>
              ) : null}
            </>
          )}
        </div>
      </React.Fragment >
    );
  }
}

export default ABM_EEX_Clientes_Detalle;
